import React from 'react';
import Layout from './layout';
import Emoji from './emoji';
import { Link } from 'react-router-dom';

const About = () => {
    return (
        <Layout selected="about">
            <div className="container min-vh-100">
                <p>
                    <Emoji emoji="👋" label="waving hand" /> Hi! My name is Vallard and I live in the Portland, Oregon area. I'm happily married and have 4 amazing kids.
                </p>
                <img src="https://s3.us-west-2.amazonaws.com/photos.torgyd.com/vallard-300.png" alt="Vallard" className="img-fluid" />
                <p className="mt-2">
                    I took my first solo trip when I was 18 to Isreal and lived on a kibbutz for several months.
                    It was the first time I ventured out. Like you, I love to travel.
                    I've realized the part I love
                    the most about it is making connections with other people. I want to make a platform to enhance the experience of travelers and the people who live in the places they visit.
                </p>
                <h4>Connect globally by connecting locally.</h4>
                <p>There are two social issues I hope to solve with this platform.</p>
                <ul>
                    <li><b>Loneliness</b> The World Health Organization (WHO) stated "that one in four people experience social isolation, and one in six adolescents is socially
                        isolated and lonley, though this is likely an underestimation."
                        (<a href="https://www.who.int/director-general/speeches/detail/who-director-general-s-opening-remarks-at-the-media-briefing-15-november-2023">Source</a>)
                        Our research has uncovered a growing trend of solo travelers lately with the majority of this trend being females.
                        We believe that connections with others is the key to happiness and we want to help people make those connections.
                        The WHO also stated that "Social connection has profound benefits for improving health, education, and the economy."
                        <br />
                        <br />
                        <p>I recently read <a href="https://the-good-life-book.com/">The Good Life</a> by Robert Waldinger and Marc Schulz.
                            In this book they talk about the Harvard Study of Adult Development which is the longest running study of adult life that's ever been done.
                            They found that the people who were the happiest and healthiest were the people who had the strongest relationships. This site is to help make more connections.
                        </p>
                    </li>
                    <br />
                    <li><b>Empower emerging entreprenuers</b> We have seen how large corporations like AirBnb or Uber have
                        taken advantage of people all over the world by taking a large percentage of their earnings. These
                        companies require an initial outlay of capital that is becomeing more difficult for most people to obtain.  Houses and cars
                        cost considerable amount of money. With a tour based business there are very little barriers to entry.
                        Anybody with some grit and hustle culture can have the flexibility to run their own business.
                        In this way I want to bring economic freedom to people all over the world. I also think that a local can give a better experience than a large corporation.
                    </li>
                </ul>

                <p className="mt-2">
                    As a lifelong traveler and a person who has lived in many different places I have made real lasting connections with people from all
                    over the world even if our contact was simply brief.
                    Travel helps eliminate fear, prejudice, and hate. It is the best education a person can have to stop wars and bring more
                    peace to the world.
                </p>
                <h3 className="mt-2">How torgyd makes money</h3>
                <p>
                    This project is evolving into a subscription-based audio tour experience. The goal is to make it easy to discover and listen to
                    location-based tours, while ensuring guides get paid fairly.
                </p>
                <ul>
                    <li>Listeners subscribe monthly for unlimited access to audio tours.</li>
                    <li>Guides earn royalties based on listen time (Spotify-style payouts).</li>
                    <li>
                        <Link to="/eatwiththenatives">Eat with the Natives</Link> is a free experimental service I think is cool that I wanted to try out.
                    </li>
                </ul>
                <p>
                    In the subscription model, the platform stays simple: users pay a subscription, guides get paid based on listening, and there’s no
                    per-tour pricing.
                </p>
            </div>
        </Layout >
    );
}

export default About;